import Form from '@utilities/form';
import API from '@utilities/api';
import moduleInit from '@utilities/module-init';
import registerConstraints from './register-constraints-trade';

const JS_HOOK_REGISTER_ALERT = '[js-hook-register-alert]';
const JS_HOOK_REGISTER_BODY = '[js-hook-trade-multistep-form]';
const JS_HOOK_CONSENT_MARKETING = '[js-hook-consent-marketing]';
const JS_HOOK_CONSENT_DIRECT_MARKETING = '[js-hook-consent-direct-marketing]';
const JS_HOOK_PRO_USER = '[js-hook-pro-user]';

class TradeMultistepForm extends Form {
    constructor(element) {
        super(element);
        this.body = element.closest(JS_HOOK_REGISTER_BODY);
        this.locale = this.form.dataset.locale;
        this.messageSelector = JS_HOOK_REGISTER_ALERT;
        this.consentMarketing = document.querySelector(JS_HOOK_CONSENT_MARKETING);
        this.consentDirectMarketing = document.querySelector(JS_HOOK_CONSENT_DIRECT_MARKETING);
        this.isprocheckbox = document.querySelector(JS_HOOK_PRO_USER);
        this.submitbtn = document.querySelector('.c-button.c-button--primary.button--block[type="submit"]');
        this.redirectElement = document.getElementById('redirect-link');
        // Init constraints
        this.initConstraints();

        // Events: Submit & Change Events
        this.bindChangeEvents();
        this.bindSubmitEvents();

        TradeMultistepForm.scrollToForm();
    }

    /**
     * Init constraints for form validation for validate.js
     */
    initConstraints() {
        this.constraints = registerConstraints(this.locale, this.customValidationMessages);
    }

    static setTradeFormCsrfToken() {
        const csrfToken = document.querySelector('[js-hook-trade-form-csrf-token]');
        if (!csrfToken) return;
        API.setAntiForgeryToken(csrfToken.name, csrfToken.value);
    }

    static scrollToForm() {
        const scrollToFormBtn = document.querySelector('#trade-multistep-form-scroll-button');
        const currentForm = document.querySelector('#main-trade-container');

        if (scrollToFormBtn && currentForm) {
            scrollToFormBtn.addEventListener('click', () => {
                currentForm.scrollIntoView({
                    behavior: "smooth"
                });
            });
        }
    }

    afterSubmitFormSuccess(data) { // eslint-disable-line class-methods-use-this
        if (data.tradeMultistepFormThankYouPageHtml) {
            const tradeMultistepFormBannerContainer = document.querySelector('.trade-multistep-form-banner-container');

            if (tradeMultistepFormBannerContainer) tradeMultistepFormBannerContainer.remove();

            document.getElementById('main-trade-container').innerHTML = data.tradeMultistepFormThankYouPageHtml;

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        } else if (data.tradeMultistepFormStepTwoHtml) {
            const modal = document.querySelector('#tradeFormStepOneModal');

            if (modal) {
                modal.classList.remove('d-none');

                const modalProceedBtn = document.querySelector('#tradeFormStepOneModalProceed');
                const body = document.querySelector('body');

                body.classList.add('overflow-hidden');

                if (modalProceedBtn) {
                    modalProceedBtn.addEventListener('click', () => {
                        document.getElementById('main-trade-container').innerHTML = data.tradeMultistepFormStepTwoHtml;

                        moduleInit.async('[js-hook-lap]', () =>
                            import( /* webpackChunkName: "js/LabelAsPlaceholder" */ '@components/form-elements/label-as-placeholder'),
                        );
                        moduleInit.async('[js-hook-trade-multistep-form]', () =>
                            // eslint-disable-next-line import/no-cycle
                            import( /* webpackChunkName: "js/TradeMultistepForm" */ './index'),
                        );
                        moduleInit.async('[js-hook-custom-select-box]', () =>
                            import(/* webpackChunkName: "js/CustomSelectBox" */ '@components/custom-select-box'),
                        );

                        TradeMultistepForm.setTradeFormCsrfToken();
                        modal.remove();
                        body.classList.remove('overflow-hidden');

                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth'
                        });
                    })
                }
            }
        }
    }

    bindChangeEvents() {
        if (this.consentMarketing && this.consentDirectMarketing) {
            this.consentMarketing.addEventListener('change', () => {
                if (this.consentMarketing.checked) {
                    this.consentDirectMarketing.removeAttribute('disabled');
                } else {
                    this.consentDirectMarketing.setAttribute('disabled', 'disabled');
                    this.consentDirectMarketing.removeAttribute('checked');
                }
            });
        }

        // Disable submit if is not pro user
        if (this.submitbtn && this.isprocheckbox) {
            const sbmBtn = this.submitbtn;

            this.isprocheckbox.addEventListener('change', () => {
                if (this.isprocheckbox.checked) {
                    sbmBtn.removeAttribute('disabled');
                } else {
                    sbmBtn.setAttribute('disabled', 'disabled');
                }
            });
        }
    }
}

export default TradeMultistepForm;
